<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Send Customer Survey</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="validationResults"></validation-results>
    <fieldset>
        <div class="mvd_form-group">
            <div *ngIf="customerNumberId">
                <label class="required" title="* Required">Customer Contact</label>
                <customer-contact [customerNumber]="customerNumberId"
                                [contacts]="customerContacts"
                                [contactId]="customerContactId"
                                [isShowSelect]="true"
                                [isShowHistory]="false"
                                [isShowTitle]="false"
                                [isAutoPopulateContacts]="false"
                                [canEdit]="false"
                                (onSelectChange)="customerContactId = $event.id">
                </customer-contact>
            </div>
            <div>
                <label class="required" title="* Required">Language</label>
                <div class="row">
                    <p-dropdown class="col-sm-4" [options]="languageCodeOptions" [(ngModel)]="languageCode"></p-dropdown>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="close()">Close</button>
        <button class="btn--primary" type="submit" (click)="onSubmitClicked()" [disabled]="!customerNumberId || !customerContactId || inProgress">Submit</button>
    </div>
</div>